<div class="relative w-full h-full">
  <div
    #mapContainer
    [id]="mapId"
    class="p-card"
    style="height: 100%; width: 100%; overflow: hidden"></div>
  @if (globalsStore.selectedGeoData()?._id; as geoDataId) {
    <div class="absolute left-0 top-0 m-2" [style]="{ 'z-index': 400 }">
      <app-geo-group-dropdown
        label=""
        headerStyleClass="hidden"
        dropDownStyleClass="dropdown-xs"
        styleClass="p-0"
        [colSize]="undefined"
        (selectionChange)="filterByGroup($event)"
        [geoDataId]="geoDataId" />
    </div>
  }
</div>
